import React from "react";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import { useGetExpenseCardStatsQuery } from "state/api";
import Loader from "components/Loader";

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "left",
    },
    title: {
      display: true,
      text: "Expense Breakdown",
    },
    colors: {
      enabled: true,
    },
  },
};

const CategoryTrends = () => {
  let { data: categoryTrends, isLoading } = useGetExpenseCardStatsQuery();
  categoryTrends = {
    ...categoryTrends?.expenseCategories,
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Doughnut
          data={{
            labels: categoryTrends?.labels,
            datasets: [
              {
                label: "Expense Amount",
                data: categoryTrends?.data,
                borderWidth: 1,
              },
            ],
          }}
          options={options}
        />
      )}
    </>
  );
};

export default CategoryTrends;
